export class CompanyIpWhitelistApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getEntries(companyId) {
    return this.#http.get(`/api/companies/${companyId}/ip-whitelist`);
  }

  async createEntry(companyId, entry) {
    return this.#http.post(`/api/companies/${companyId}/ip-whitelist`, entry);
  }

  async updateEntry(companyId, id, entry) {
    return this.#http.put(`/api/companies/${companyId}/ip-whitelist/${id}`, entry);
  }

  async deleteEntry(companyId, id) {
    return this.#http.delete(`/api/companies/${companyId}/ip-whitelist/${id}`);
  }
}
